import styled from "styled-components";

const ButtonBase = styled.button`
  font-family: "Inter", sans-serif;
  font-weight: 600;
  border-radius: 8px;
  width: 100%;
  font-size: var(--fontSize);
  padding: var(--padding);
  margin-top: var(--marginTop);
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: center;

  & svg {
    width: var(--iconSize);
    height: var(--iconSize);
  }
`;

export const FillButton = styled(ButtonBase)`
  background-color: ${(props) => props.theme.palette.primary.blue500};
  color: #fff;
  border: 2px solid transparent;
`;
export const OutlineButton = styled(ButtonBase)`
  background-color: transparent;
  color: ${(props) => props.theme.palette.primary.blue500};
  border: 2px solid currentColor;
`;
export const GhostButton = styled(ButtonBase)`
  color: ${(props) => props.theme.palette.primary.blue500};
  background-color: #fff;
`;
